var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "set-password-content" },
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "password-setup-form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("VuePassword", {
            staticClass: "password-field",
            attrs: { strength: _vm.strength },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
          _vm._v(" "),
          _c(
            "v-container",
            {
              staticClass: "strength-message",
              class: _vm.strengthMessageClass,
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "password-strength",
                  attrs: { align: "center", justify: "center" },
                },
                [
                  _c("v-col", [
                    _vm._v(
                      "\n          " + _vm._s(_vm.strengthMessage) + "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "password-requirements", attrs: { fluid: "" } },
            [
              _c("ul", [
                _c("li", { class: { done: _vm.requirements.length } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.passwordMinimumLength) +
                      " characters minimum\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { class: { done: _vm.requirements.strength } }, [
                  _vm._v(
                    "\n          Minimum password strength: Strong Password\n          "
                  ),
                  _c(
                    "ul",
                    _vm._l(_vm.strengthTips, function (tip) {
                      return _c("li", { staticClass: "suggestion" }, [
                        _vm._v(_vm._s(tip)),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }